<template>

  <div>
    <div class="content contentTerms" :class="theme==0?'dark':'white'">
      <div class="mainDiv">
        <section class="topTitle">
          <img src="/static/img/work/argreementLogo.png" alt="">
          薄盒软件帐号注销协议
        </section>
        <section class="privacy-tableOfContents privacy-content">
          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <p>
                    尊敬的用户，在您正式开始下一步有关本软件的帐号注销流程前，我们先为您做出如下特别说明：注销本帐号后，除法律法规另有规定外，您在该帐号下的个人信息将进行删除或匿名化处理。该帐号一旦注销完成，将无法恢复，请您谨慎操作。
                  </p>
                  <p class="desc">
                    若您经过慎重考虑后仍决定注销本帐号的，请您务必先行仔细阅读和充分理解本《薄盒软件帐号注销协议》（“本协议”），并同意本协议全部内容。您按照我们的注销操作流程开始注销流程的，或者您勾选本注销协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。
                  </p>
                  <p class="desc">
                    为确保注销的顺利完成，在成功提交注销申请后不要登录和使用该帐号。 为了保障您的合法权益，我们设置了 7 日的冷静期，如果您在成功申请注销账号后的7 日内再次登录的，即视为您撤回注销申请；若 7
                    日内未登录，则该账号将完成注销。
                  </p>
                  <p class="desc">
                    如您在注销后需要再次使用我们的服务的，欢迎您重新注册帐号并登录。
                  </p>
                  <p class="desc">
                    一、您知悉并同意：在您的帐号注销后，将（可能）产生包括但不限于如下结果，并需要您自行承担：
                  </p>
                  <p class="desc">
                    1. 您将无法登录、使用该帐号。即使您使用相同的手机号再次注册，您无法继续通过本软件访问您的数字资产，如您需要通过其他方式访问数字资产的，请联系客服获取协助；
                  </p>
                  <p class="desc">
                    2. 除法律法规另有规定外，您该帐号下的个人信息将会被删除或匿名化处理。您无法再找回您的个人信息，也无权要求我们找回，前述个人信息包括但不限于：头像、昵称、图片、购买记录等内容；
                  </p>
                  <p class="desc">
                    3.
                    本帐号一旦注销，将无法恢复。即使您在注销后以相同或其他薄盒提供的登录方式作为帐号再次向我们申请注册登录本软件的，此时该帐号将视为新的用户帐号。因此，我们善意地提醒您在申请注销前对需要备份的内容提前做好备份；
                  </p>
                  <p class="desc">
                    4.
                    本帐号一旦注销（指帐号正式注销），您与我们签署的《薄盒软件许可及服务协议》（“用户协议”）终止（但已约定继续生效的除外）。但用户协议的终止并不影响帐号注销前您使用本服务应当承担的相关责任，您仍需要对帐号注销前使用本服务的行为承担相应责任，包括但不限于可能产生的违约责任、损害赔偿责任及履约义务等。
                  </p>
                  <p class="desc">
                    5. 其他因帐号注销（可能）产生的结果。
                  </p>
                  <p class="desc">
                    二、在您向我们申请/继续申请注销帐号之前，为保障您的帐号安全和相关权益，您需先行检查与确保您申请注销的帐号已经同时满足以下条件，这些条件包括但不限于：
                  </p>
                  <p class="desc">
                    1. 该帐号为您本人合法拥有并登录使用；
                  </p>
                  <p class="desc">
                    2. 该帐号处于正常使用中且无被封、被盗等安全风险；
                  </p>
                  <p class="desc">
                    3. 该帐号无任何纠纷：包括投诉举报、被投诉举报、国家机关调查、仲裁、诉讼等纠纷。
                  </p>
                  <p class="desc">
                    上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系薄盒客服协助处理。
                  </p>
                  <p class="desc">
                    三、如何注销帐号
                  </p>
                  <p class="desc">
                    1. 您需按照本软件提供的注销流程和操作指引，在相关功能设置页面进行注销操作。
                  </p>
                  <p class="desc">
                    2. 您已经同意本注协协议的全部内容；同时，您已经检查与确认满足了本协议第二条的要求。
                  </p>
                  <p class="desc">
                    3.
                    在您完成上述第2点后，为进一步保障您的相关合法权益，我们有权（并非义务）根据您的帐号安全状态以及您的相关产品与服务的使用情况等综合判断您的帐号是否符合注销条件。为保障您的帐号安全和其他合法权益，我们有权进行注销申请的身份验证以判断您是该帐号的有权使用人（如手机验证方式等）。如我们在综合判断后发现该帐号不符合注销条件的，或者身份验证失败的，您的注销可能会失败，您可以按照我们的指引进行后续操作或联系薄盒客服协助处理。即使我们判断您符合注销条件的，也是基于您的承诺（即您自身确保帐号符合上述注销条件的承诺）进行的形式审查，仍由您自身对帐号符合上述注销条件承担保证责任，我们对此不承担相应的法律责任。
                  </p>
                  <p class="desc">
                    4. 我们在您成功完成上述第3点的“身份验证”且成功提交帐号注销申请后的15日内完成帐号注销。为确保注销的顺利完成，请您在提交注销申请后不要登录和使用该帐号，否则视为您撤销注销该帐号。
                  </p>
                  <p class="desc">
                    具体的注销流程化和操作以薄盒公司官方公布的为准。您理解并同意，在您申请注销帐号期间（即您已经成功提出注销申请但帐号未完成注销期间），如我们需要对相关投诉或其他与您的帐号相关的事项进行核实的，或者我们有其他合理的理由的，我们有权冻结您的该帐号且暂时不为您提供注销服务。
                  </p>
                  <p class="desc">
                    四、其他
                  </p>
                  <p class="desc">
                    本协议为《薄盒软件许可及服务协议》（“主协议”）组成部分，本协议未尽事宜适用主协议。本协议与主协议不一致的，以本协议为准。同时，您知悉并同意，即使您的帐号被注销，也并不减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。
                  </p>
                  <p class="desc">
                    如在帐号注销过程中有任何问题您无法处理的或在处理过程中有任何疑惑的，可联系薄盒客服协助处理。
                  </p>
                  <p class="desc" style="text-align:right">
                    北京擘盒科技有限公司
                  </p>
                </div>
              </li>

            </ul>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "",

    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }
  }

</script>
<style scoped="scoped" lang="less">
  .contentTerms {
    background: #0c0c0c;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    /* color: #5bb6fa; */
    color: #83878b !important;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #83878b !important;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #bdbdbd;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878b;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

  .dark {
    background: #000000;

    .main {
      background-color: #0C0C0C;
      color: #8d8f9f;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    }

  }

  .white {
    background: #ffffff;

    .main {
      background-color: #f1f1f1;
      color: #333333;
      box-shadow: 0px 1px 2px 0px rgba(226, 226, 226, 0.5);
    }

    .topTitle {
      color: #333333;
    }

    .privacy-content {
      color: #333333;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/cancellationAgreement.vue